import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { useToast } from "../../context/ToastContext";
import { useTranslationContext } from "../../context/TranslationContext";
import * as PR from "../../prime-modules/index";

const UpdatePaymentMethod = ({ clientSecret, setupIntentId, iccid }) => {
  const { labelsIot } = useTranslationContext();
  const { showToast } = useToast();
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ FIRST: submit elements to prepare (for Apple/Google Pay)
    const { error: submitError } = await elements.submit();
    if (submitError) {
      return;
    }

    const { error } = await stripe.confirmSetup({
      clientSecret,
      elements,
      confirmParams: {
        return_url: window.location.href + `?payment_method_update=true&iccid=${iccid}&setupIntentId=${setupIntentId}`,
      },
    });

    if (error) {
      showToast("error", error.message);
    }
  };

  return (
    <div className="grid payment-card-section">
      <div className="col-12">
        <p>{labelsIot?.LBLI0151}</p>
      </div>
      <form onSubmit={handleSubmit} className="w-12">
        <PaymentElement options={{ layout: "tabs" }} />
        <div className="col-12 p-0 mt-2">
          <PR.Button
            label={labelsIot?.LBLI0152}
            type="submit"
            className="device-confirm-button w-full mt-2"
          />
        </div>
      </form>
    </div>
  );
};

export default UpdatePaymentMethod;
